import { READ_EXCHANGE_BILLING, SET_DISCOUNTED_PERCENTAGE, SET_NEW_PAY, SET_SELECTED_PLUGIN, SET_UPDATED_PLUGIN } from '../config/actionTypes';

const initialState = {
	paidBilling: [],
	pendingBilling: [],
	invoice: [],
	isNewPay: false,
	isEdit: false,
	invoice_id: 0,
	discountedPercentage: 0,
	updatedPlugin: [],
	selectedpluginDetail: [],
};

const StatReducer = (state = initialState, action) => {
	const { data } = action;
	switch (action.type) {
		case READ_EXCHANGE_BILLING:
			return {
				...state,
				...data
			};
		case SET_NEW_PAY:
			return {
				...state,
				...data
			};
		case SET_DISCOUNTED_PERCENTAGE:
			return {
				...state,
				discountedPercentage: data
			}
		case SET_UPDATED_PLUGIN:
			return {
				...state,
				updatedPlugin: data
			}
		case SET_SELECTED_PLUGIN:
			return {
				...state,
				selectedpluginDetail: data
			}
		default:
			return state;
	}
};

export default StatReducer;
